export const HealthStatus = {
  InProgress: 'INPROGRESS',
  Disabled: 'DISABLED',
  Completed: 'COMPLETED'
};
